const config = {
  url: window.location.hostname === 'www.jclub.com.my' || window.location.hostname === 'jclub.com.my' 
      ? 'https://api.jclub.com.my/'
      : 'https://uatapi.jclub.com.my/'
};

export default config;